import { NONE_GAME_ID } from "./games.js";
import { normalizeScalingMode } from "./scaling.js";

const MAX_MEGAPIXELS = 64;

export const LIMITS = {
    minTileResolution: 16,
    maxTileResolution: 2048,
    maxTiles: 400,
    maxTotalPixels: MAX_MEGAPIXELS * 1024 * 1024
};

export function isPositiveInteger(value) {
    return Number.isInteger(value) && value > 0;
}

export function coerceInt(value, fallback = 0) {
    const parsed = Number.parseInt(String(value), 10);
    return Number.isFinite(parsed) ? parsed : fallback;
}

export function validateConfig(config) {
    const errors = [];
    const tilesWide = coerceInt(config.tilesWide);
    const tilesHigh = coerceInt(config.tilesHigh);
    const tileResolution = coerceInt(config.tileResolution);
    const scalingMode = normalizeScalingMode(config.scalingMode);

    if (!isPositiveInteger(tilesWide)) {
        errors.push("Tiles wide must be a positive whole number.");
    }

    if (!isPositiveInteger(tilesHigh)) {
        errors.push("Tiles high must be a positive whole number.");
    }

    if (!isPositiveInteger(tileResolution)) {
        errors.push("Tile resolution must be a positive whole number.");
    }

    if (tileResolution < LIMITS.minTileResolution || tileResolution > LIMITS.maxTileResolution) {
        errors.push(`Tile resolution must be between ${LIMITS.minTileResolution} and ${LIMITS.maxTileResolution}.`);
    }

    const tileCount = tilesWide * tilesHigh;
    if (tileCount > LIMITS.maxTiles) {
        errors.push(`Requested tile count (${tileCount}) exceeds limit (${LIMITS.maxTiles}).`);
    }

    const totalPixels = tilesWide * tilesHigh * tileResolution * tileResolution;
    if (totalPixels > LIMITS.maxTotalPixels) {
        errors.push(`Requested output exceeds pixel limit (${MAX_MEGAPIXELS} megapixels).`);
    }

    return {
        isValid: errors.length === 0,
        errors,
        normalized: {
            tilesWide,
            tilesHigh,
            tileResolution,
            scalingMode,
            gameId: config.gameId ?? NONE_GAME_ID
        }
    };
}

export function validateImageFile(file) {
    if (!file) {
        return "Select an image file before generating.";
    }

    const allowed = ["image/png", "image/jpeg", "image/webp"];
    if (!allowed.includes(file.type)) {
        return "Image format is unsupported. Use PNG, JPG, or WEBP.";
    }

    return "";
}
